import React, { FC } from 'react';

import { List, ContainerProps } from '@lglp/components';
import { LinkType } from '@lglp/prismic-client';
import { useTranslation } from 'react-i18next';

import { SHORTCUTS } from 'translations';

import { LinkedComponent } from '../../LinkedComponent';
import styles from './Shortcuts.module.scss';

export const ID = {
  MAIN: 'main',
  FOOTER: 'footer',
  NAVIGATION: 'navigation',
};

export const Shortcuts: FC<ContainerProps> = ({ className, ...rest }) => {
  const { t } = useTranslation();

  return (
    <List className={[styles.shortcuts, className]} {...rest}>
      <List.Item>
        <LinkedComponent
          link={{ linkType: LinkType.Web, url: `#${ID.MAIN}` }}
          className={styles.shortcutLink}
        >
          {t(SHORTCUTS.LABEL_MAIN)}
        </LinkedComponent>
      </List.Item>
      <List.Item>
        <LinkedComponent
          link={{ linkType: LinkType.Web, url: `#${ID.NAVIGATION}` }}
          className={styles.shortcutLink}
        >
          {t(SHORTCUTS.LABEL_NAVIGATION)}
        </LinkedComponent>
      </List.Item>
      <List.Item>
        <LinkedComponent
          link={{ linkType: LinkType.Web, url: `#${ID.FOOTER}` }}
          className={styles.shortcutLink}
        >
          {t(SHORTCUTS.LABEL_FOOTER)}
        </LinkedComponent>
      </List.Item>
    </List>
  );
};
